const resources = [
  {
    icon: "ri-file-pdf-2-line",
    title: "Sample assessment report",
    desc: "A redacted, end-to-end example — findings, fixes, source-clause traceability.",
    meta: "PDF · 12 pages",
    href: "#sample",
  },
  {
    icon: "ri-book-open-line",
    title: "How to use the system",
    desc: "Self-serve flow, enterprise flow, how to read the report, what we do with your data.",
    meta: "Web page · 5 min read",
    href: "#how",
  },
  {
    icon: "ri-building-4-line",
    title: "Enterprise sample (14 products, 4 models)",
    desc: "A telecom-scale portfolio with COMPL-AI model-layer evidence and hash-signed trail.",
    meta: "PDF · 28 pages",
    href: "#sample",
  },
  {
    icon: "ri-refresh-line",
    title: "Regulatory changelog",
    desc: "How we track EU AI Act developments and flow them into your reports.",
    meta: "Web page · updated monthly",
    href: "#",
  },
];

export default function Resources() {
  return (
    <section id="resources" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="section-head">
          <p className="eyebrow">
            <i className="ri-folder-open-line" />
            Resources
          </p>
          <h2 className="section-title">
            Read before you book
          </h2>
          <p className="section-lede">
            Short, opinionated documents your legal and ML teams can share without translation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-6xl mx-auto">
          {resources.map((res) => (
            <a
              key={res.title}
              href={res.href}
              className="card group hover:border-primary-300/60 hover:shadow-md transition-all duration-300 flex flex-col"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-4 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${res.icon} text-xl`} />
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors">
                {res.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                {res.desc}
              </p>
              <span className="text-xs text-foreground-500 font-medium">{res.meta}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}